import {Injectable} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "@cx-env/environment";

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  source = null
  _param1 = null
  _param2 = null
  constructor(
    private aR: ActivatedRoute,
  ) {
    this.aR.queryParams
      .subscribe(params => {
          this.source = params['source'];
        }
      );
  }

  initSource(){
    if(!this.source){
      this.source = this.aR.snapshot.queryParamMap.get('source');
    }
  }
  isDewa19(eventId: number){
    return eventId === environment.dewa19id;
  }
  isBsr(id: number){
    return id === environment.bsrId;
  }
  isBi(id: number){
    return environment.biIdList.includes(id);
  }
  get isSukha(){
    return this.source === 'mandiri_sukha' || this.source === 'sukha' || this.isProliga;
  }
  get isOnePiece(){
    return window.location.hostname === 'opcindonesia.addtix.id';
  }
  get isProliga(){
    return window.location.hostname === 'proliga.addtix.id';
  }
  get isAK(){
    return window.location.hostname === 'a2j0k2t24.addtix.id';
  }
  get isRichieRen(){
    return window.location.hostname === 'c2a0l25.addtix.id' ;
  }
  get isHillsong(){
    return window.location.hostname === '1h1l2o5.addtix.id' ;
  }
  get isSocialchic(){
    return window.location.hostname === 'socialchic.addtix.id';
  }
  isJDIO(id: number){
    return environment.JDIOId === id ;
  }
  isJDIOID(id: number){
    return environment.JDIOIDId === id ;
  }
  isRawDance(id: number){
    return environment.rawDanceId === id;
  }

  isRawDanceCategoryPromo(id: number){
    return id === 2068;
  }
  set param1(params1: string){
    this._param1 = params1
  }
  get param1(){
    return this._param1;
  }
  set param2(params2: string){
    this._param2 = params2
  }
  get param2(){
    return this._param2;
  }
  get getWhiteLabel(){
    const whiteLabels = environment.whiteLabel;
    return whiteLabels.find((w) => {
      return window.location.pathname.includes(w.slug);
    }) as any
  }
}
